import React from 'react';
import {
  ImageContainer,
  SectionContainer,
  SimpleBandContainer,
} from './styles/SectionSimpleBand.styles';
import { CtaButtonRowProps } from '../../Elements/CtaButtons/types/CtaButtonRow.types';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { RichTextProps } from '../../Elements/RichText/RichText';
import CtaButtonRow from '../../Elements/CtaButtons';
import RichTextElement from '../../Elements/RichText';
import Spacing from '@legacy-vfuk/core-spacing';

export type SectionSimpleBandProps = {
  image: {
    gatsbyImageData: IGatsbyImageData;
    description: string;
  };
  content: RichTextProps[];
  imageAlignment: 'left' | 'right';
  backgroundColor: 'white' | 'grey';
  buttonRow?: CtaButtonRowProps;
};

const SectionSimpleBand: React.FC<SectionSimpleBandProps> = ({
  image,
  content,
  imageAlignment,
  buttonRow,
  backgroundColor,
}) => {
  if (content.length > 1) {
    throw new Error('Only one content entity is supported!');
  }

  return (
    <SectionContainer backgroundColor={backgroundColor}>
      <SimpleBandContainer>
        <ImageContainer
          imageAlignment={imageAlignment}
          data-testid="section-simple-band-image-container"
        >
          <GatsbyImage
            image={getImage(image) as IGatsbyImageData}
            alt={image.description}
          />
        </ImageContainer>
        <div>
          <RichTextElement {...content[0]} rawRichText={content[0].text?.raw} />
        </div>
      </SimpleBandContainer>

      {buttonRow && (
        <Spacing spacingLevel={{ top: 8 }}>
          <CtaButtonRow {...buttonRow} />
        </Spacing>
      )}
    </SectionContainer>
  );
};

export default SectionSimpleBand;
